import { type AppEnvironment } from "@/core/env";

const APP_ENV_TO_TITLE = {
  development: "Volca (Dev)",
  staging: "Volca (Staging)",
  demo: "Volca (Demo)",
  production: "Volca",
} as const;

export const formatDocumentTitle = (
  page: string | undefined,
  env: AppEnvironment,
) => {
  const app = APP_ENV_TO_TITLE[env];
  return page ? `${page} · ${app}` : app;
};
